import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialHelperModule } from 'src/app/core/material-helper.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ProblemCardComponent } from './problem-card/problem-card.component';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { FolioDialogComponent } from './folio-dialog-component/folio-dialog.component';

@NgModule({
    declarations: [ProblemCardComponent, SafePipe, FolioDialogComponent],
    imports: [
        CommonModule,
        MaterialHelperModule,
        FormsModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        NgxMaterialTimepickerModule,
        DragDropModule,
    ],
    exports: [
        CommonModule,
        MaterialHelperModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        NgxMaterialTimepickerModule,
        DragDropModule,
        ProblemCardComponent,
        SafePipe
    ]
})
export class SharedModule { }
